enum routings {
  HOME = "/app/home",
  JOIN = "/app/join",
  MEETING = "/app/meeting",
  FEEDBACK = "/app/feedback",
  AUTHSCREEN = "/app/",
  WAITINGROOM = "/app/waitingroom",
  DASHBOARD = "/app/dashboard",
  SCHEDULE = "/app/dashboard/schedule",
  SCHEDULEMEETING = "/app/dashboard/meeting",
  CHAT = "/app/dashboard/chat",
  SMS = "/app/dashboard/sms/",
  CALLS = "/app/dashboard/pbx",
  PAST = "/app/dashboard/past-meetings",
  LIST = "/app/dashboard/chat/members",
  SEARCHRESULT = "/app/dashboard/search-result",
  WARNING = "/app/not-supported",
}
export default routings